import { render, staticRenderFns } from "./destination.vue?vue&type=template&id=1c0680aa&scoped=true&"
import script from "./destination.vue?vue&type=script&lang=js&"
export * from "./destination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0680aa",
  null
  
)

export default component.exports